export default {
  templatesReviewRequest: {
    templateJson: {},
    templateHtml: '',
    previewHTML: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {
      fromName: '',
      fromEmail: '',
      subject: '',
      preheader: '',
    },
    countryEmailTemplates: {},
    countryEmailAdvancedTemplates: [],
  },
  templatesCoupon: {
    templateJson: {},
    templateHtml: '',
    previewHTML: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {
      fromName: '',
      fromEmail: '',
      subject: '',
      preheader: '',
    },
    countryEmailTemplates: {},
    countryEmailAdvancedTemplates: [],
  },
  templatesVerifyEmail: {
    templateJson: {},
    templateHtml: '',
    previewHTML: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {
      fromName: '',
      fromEmail: '',
      subject: '',
      preheader: '',
    },
    countryEmailTemplates: {},
    countryEmailAdvancedTemplates: [],
  },
  templatesThxPage: {
    templateJson: {},
    templateHtml: '',
    previewHTML: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {},
    countryEmailTemplates: {},
  },
  templatesReviewRequestSMS: {
    templateJson: { text: '' },
    templateHtml: '',
    previewText: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {
      fromName: '',
    },
    countryEmailTemplates: [],
  },
  templatesOrderPrinter: {
    templateJson: { text: '' },
    templateHtml: '',
    previewText: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
  },
  templatesPhotoRequest: {
    templateJson: {},
    templateHtml: '',
    previewHTML: '',
    mergeTags: {
      optional: [],
      required: [],
      tutorial: {},
    },
    settings: {
      fromName: '',
      fromEmail: '',
      subject: '',
      preheader: '',
    },
    countryEmailTemplates: {},
    countryEmailAdvancedTemplates: [],
  },

  mergeTags: {
    optional: [],
    required: [],
    tutorial: {},
  },

  settingsReviewRequest: {
    fromName: '',
    fromEmail: '',
    subject: '',
    preheader: '',
  },
  settingsCoupon: {
    fromName: '',
    fromEmail: '',
    subject: '',
    preheader: '',
  },
  settingsVerifyEmail: {
    fromName: '',
    fromEmail: '',
    subject: '',
    preheader: '',
  },
  settingsReviewRequestSMS: {
    fromName: '',
  },

  previewReviewRequestHTML: '',
  previewCouponHTML: '',
  previewVerifyEmailHTML: '',
  previewThankPageHTML: '',
  previewReviewRequestSMS: '',
  previewOrderPrinter: '',

  saveDesignReviewRequest: {
    templateJson: {},
    templateHtml: '',
  },
  saveDesignCoupon: {
    templateJson: {},
    templateHtml: '',
  },
  saveDesignVerifyEmail: {
    templateJson: {},
    templateHtml: '',
  },
  saveDesignThxPage: {
    templateJson: {},
    templateHtml: '',
  },
  saveDesignPhotoRequest: {
    templateJson: {},
    templateHtml: '',
  },
  saveDesignReviewRequestSMS: {
    templateJson: {},
    templateHtml: '',
  },

  general: {
    destinationEmail: '',
  },

  templateName: '',
  resetTemplate: '',

  newResetDesign: {},
  originalValues: {},
  testFlow: {
    email: null,
    products: [],
    reviewRequest: null,
    productWidget: null,
  },
};
